/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ age: NonNullable<unknown> }} Requestage1Inputs */

const en_requestage1 = /** @type {(inputs: Requestage1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.age} years`)
};

const de_requestage1 = /** @type {(inputs: Requestage1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.age} Jahre`)
};

/**
* | output |
* | --- |
* | "{age} years" |
*
* @param {Requestage1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestage1 = /** @type {((inputs: Requestage1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestage1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestage1(inputs)
	return de_requestage1(inputs)
});
export { requestage1 as "requestAge" }